module.exports = __webpack_public_path__ + "91c2115c977883b80e13786a8bf4a17a.svg";